import { List } from '@telegram-apps/telegram-ui';
import { FC } from 'react';
import { QuestSectionSkeleton } from './QuestSectionSkeleton';

export const QuestDaySkeleton: FC = () => {
  return (
    <List
      style={{
        background: 'var(--tgui--secondary_bg_color)',
        padding: 10,
        paddingBottom: '80px',
        flex: 1,
        minHeight: 0,
        overflowY: 'auto',
        WebkitOverflowScrolling: 'touch',
      }}
    >
      <QuestSectionSkeleton itemCount={3} />
      <QuestSectionSkeleton itemCount={4} />
    </List>
  );
};

